import ModalLayout from "app/components/Layouts/ModalLayout/ModalLayout";
import React from "react";
import styles from "./styles.module.scss";
import { Trans, useTranslation } from "react-i18next";
import Ads from "../../../../public/images/cn-ads.svg";
import { useHistory } from "react-router-dom";
import { DateTime } from "luxon";
import ButtonVariant from "app/components/Button/ButtonVariant";

type Flow = 'programs' | 'booking' | 'packages';
interface Props {
  isOpen: boolean;
  onClose: () => void;
  flow: Flow;
  urlValues: { programId?: string, coachId: string, coachName?: string, productId?: string, stripeId?: string };
  headerValues: { date?: DateTime, clinic?: string };
}

const AuthenticateModal = ({ isOpen, onClose, flow, urlValues, headerValues }: Props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const isBookingFlow = flow === "booking";
  const isPackagesFlow = flow === "packages";

  const onSignUpClick = () => {
    let url = '';

    switch (flow) {
      case 'booking':
        url = `/signup?return_url=${encodeURIComponent('/public/confirmation')}&coach_name=${urlValues.coachName}&coach_id=${urlValues.coachId}&phoneRequired=true`;
        break;
      case 'programs': {
        const programs_return_url = encodeURIComponent(`/programs/${urlValues.programId}/view?coach_id=${urlValues.coachId}&isSignIn=true`);
        url = `/signup?return_url=${programs_return_url}&phoneRequired=true`;
        break;
      }
      case 'packages': {
        const packages_return_url = encodeURIComponent(`/post-login?coach_id=${urlValues.coachId}&productId=${urlValues.stripeId}`);
        url = `/signup?return_url=${packages_return_url}&coach_name=${urlValues.coachName}&coach_id=${urlValues.coachId}&phoneRequired=true`;
        break;
      }
    }
    history.push(url);
  };

  const onSignInClick = () => {
    let url = '';
    switch (flow) {
      case 'booking':
        url = `/signin?return_url=${encodeURIComponent('/public/confirmation')}&coach_name=${urlValues.coachName}&coach_id=${urlValues.coachId}&phoneRequired=true`;
        break;
      case 'programs': {
        const programs_return_url = encodeURIComponent(`/programs/${urlValues.programId}/view?coach_id=${urlValues.coachId}&isSignIn=true`);
        url = `/signin?return_url=${programs_return_url}`;
        break;
      }
      case 'packages': {
        const packages_return_url = encodeURIComponent(`/post-login?coach_id=${urlValues.coachId}&productId=${urlValues.stripeId}&isSignIn=true`);
        url = `/signin?return_url=${packages_return_url}&coach_name=${urlValues.coachName}&coach_id=${urlValues.coachId}&phoneRequired=true`;
        break;
      }
    }
    history.push(url);
  };

  let headerKey: string;
  let headerValuesForTrans: Record<string, any> = {};

  if (isBookingFlow) {
    headerKey = "booking_modal_content";
    headerValuesForTrans = {
      coach: urlValues.coachName,
      date: headerValues.date
        ? headerValues.date.toFormat("MMM dd, yyyy")
        : "",
    };
  } else if (isPackagesFlow) {
    headerKey = "offerings_modal_content";
    headerValuesForTrans = {
      coach: urlValues.coachName,
    };
  } else {
    headerKey = "programs_modal_content";
    headerValuesForTrans = {
      clinic: headerValues.clinic,
    };
  }

  const bookingLikeFlow = isBookingFlow || isPackagesFlow;

  return (
    <ModalLayout
      isOpen={isOpen}
      onClose={onClose}
      classNames={styles.max_h_90vh}
      wrapperClassName={styles.wrapper}
    >
      <div className={styles.container}>
        <div className={styles.row}>
          <span className={styles.close_icon} onClick={onClose}>
            <i className="ico ico-x" />
          </span>
        </div>
        <div className={styles.ads_text_container}>
          <Trans
            i18nKey={headerKey}
            components={{ strong: <strong /> }}
            values={headerValuesForTrans}
          />
        </div>
        <div className={styles.ads_container}>
          <img src={Ads} alt="coach now ads" />
        </div>
        <div className={styles.bottom_container}>
          <div className={styles.action_container}>
            <div className={styles.text_container}>
              <p className={styles.question}>{t("New to CoachNow?")}</p>
              <p className={styles.answer}>
                {bookingLikeFlow ?
                  t("Create an account to complete your booking. It's 100% free and sign up takes less than a minute.") :
                  t("Create an account to complete your registration. It's 100% free and sign up takes less than a minute.")
                }
              </p>
            </div>
            <ButtonVariant
              title={t("Create CoachNow Account")}
              buttonType='primary'
              onClickFunc={onSignUpClick}
              buttonStyles={styles.button}
            />
          </div>
          <div className={styles.action_container}>
            <div className={styles.text_container}>
              <p className={styles.question}>{t("Already a CoachNow user?")}</p>
              <p className={styles.answer}>
                {bookingLikeFlow ?
                  t("Sign in below to finalize your booking.") :
                  t('Sign in to finalize your registration.')
                }
              </p>
            </div>
            <ButtonVariant
              title={t("Sign In to CoachNow")}
              buttonType='primary'
              onClickFunc={onSignInClick}
              buttonStyles={styles.button}
            />
          </div>
        </div>
      </div>
    </ModalLayout>
  );
};

export default AuthenticateModal;
